import React from "react";
import { Icon } from "@chakra-ui/react";

export const ArrowDownIcon = ({ ...props }) => {
  return (
    <Icon
      as="svg"
      viewBox="0 0 7 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.64979 0.759275L0.34961 0.759274C0.285824 0.759474 0.2233 0.777067 0.168769 0.810158C0.114237 0.843249 0.0697632 0.890586 0.0401334 0.947073C0.0105037 1.00356 -0.00315957 1.06706 0.000614592 1.13073C0.00438875 1.19441 0.0254573 1.25585 0.0615525 1.30844L3.21164 5.85857C3.3422 6.04722 3.6565 6.04722 3.78741 5.85857L6.9375 1.30844C6.97396 1.25596 6.99534 1.19449 6.99932 1.13071C7.0033 1.06693 6.98972 1.00327 6.96007 0.946668C6.93041 0.890061 6.88581 0.842663 6.83111 0.809626C6.7764 0.776588 6.71369 0.759174 6.64979 0.759275Z"
        fill="currentColor"
      />
    </Icon>
  );
};
